import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import AccountMenu  from '../../Modules/AccountMenu'

import LidstudiecelAdd from '../../Modules/Kennis/Toevoegen/LidstudiecelAdd';

class MemberLidmaatschapAddLidstudiecel extends Component {
  render() {
    return (
      <div className="route">
      <AccountMenu/>
        <div className="grey-bg">
            <h1 className="pageTitle">
                Lid studiecel toevoegen
            </h1>
            <p>Op deze webpagina kunt u uw permanente educatie activiteiten invullen.</p>
            <p>Bij bekende opleidingen en cursussen kunt u selecteren uit het opleidingen- en cursussenbestand van het Constructeursregister. U krijgt dan direct het aantal kenniseenheden te zien. Definitieve toewijzing van de kenniseenheden vindt plaats na beoordeling door de toetsingscommissie. Klik hier voor de toelichting..</p>
            <hr/>
            <Row>
              <Col md={12}>
              {/* TODO: New form */}
                <LidstudiecelAdd />
              </Col>
            </Row>
            {/* <Bijeenkomst /> */}
        </div>
      </div>
    );
  }  
}

export default MemberLidmaatschapAddLidstudiecel;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Toevoegen/LidstudiecelAdd.js